import { useContext } from 'react';
import { FireAlarmContext } from './fire-alarm.context';

export function useFireAlarm() {
  const ctx = useContext(FireAlarmContext);
  if (!ctx) {
    throw new Error('useFireAlarm must be used inside <FireAlarmProvider>');
  }
  return ctx;
}
